import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Table, DropdownButton, MenuItem, Clearfix } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';
import { forEach as _forEach, find as _find } from 'lodash';

import { getVariantDescription } from 'helpers/items';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { docTemplateOptionFromEntity } from 'components/forms/autocomplete/DocTemplate';
import { clientOptionFromEntity } from 'components/forms/autocomplete/Client';
import { getNetFromGross, getGrossFromNet } from 'helpers/financial';

import EntityStateUpdater from 'component/EntityStateUpdater';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormHoldingCompany from 'components/forms/FormHoldingCompany';
import DatePicker from 'components/forms/DatePicker';
import FormRichEditor from 'components/forms/FormRichEditor';
import FormItemSearch from 'components/forms/FormItemSearch';
import FormErrors from 'components/forms/FormErrors';
import List from 'components/List';

import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import SalesDocumentSummary from 'components/layout/SalesDocumentSummary';
import ItemVariantSelectors from 'components/layout/itemDetails/ItemVariantSelectors';

import Entity from 'components/Entity';
import Data from 'components/Data';

import { entityMetaMapping } from 'js/constants';

class ConvertQuoteFromTemplateForm extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entity: null,
      entityLoaded: false,
      editedRow: null,
      owner: null,
      showEditDeliveryDate: false,
      showEditComment: false,
      showAddItem: false,
      itemVariantValidation: {},
    };

    this.entity = new Entity();
    if (props.meta[entityMetaMapping.quote] !== undefined && !props.meta[entityMetaMapping.quote].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.quote);

      this.state = {
        ...this.state,
        entity: this.entity,
      };
    }
  }

  componentDidMount = () => {
    const { show } = this.props;

    if (show) {
      this.onShow();
    }
  };

  componentDidUpdate = prevProps => {
    const { meta, show, formStatus, onSubmitParent } = this.props;

    if (
      meta[entityMetaMapping.quote] !== undefined &&
      !meta[entityMetaMapping.quote].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.quote);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (show && !prevProps.show) {
      this.onShow();
    }

    if (!show && prevProps.show) {
      this.onExit();
    }

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError && onSubmitParent) {
      onSubmitParent(formStatus.response);
    }
  };

  getDeposit = () => {
    const { webApp } = this.props;
    const { entityLoaded, entity } = this.state;

    if (entityLoaded) {
      let valueLabel;
      let typeLabel;
      const value = entity.deposit || (entity.getDeposit && entity.getDeposit()) || 0;
      const type = entity.deposit_type || (entity.getDepositType && entity.getDepositType()) || 'percent';

      switch (type) {
        case 'fixed': {
          typeLabel = webApp.currencySymbol;
          valueLabel = (
            <FormattedNumber
              value={value}
              style="currency"
              currency={entity.currency || (entity.getCurrency && entity.getCurrency())}
            />
          );
          break;
        }

        case 'percent':
        default: {
          typeLabel = '%';
          valueLabel = <FormattedNumber value={value / 100} style="percent" />;
          break;
        }
      }

      return { valueLabel, value, typeLabel, type };
    }
  };

  depositValueOptions = () => {
    const { type } = this.getDeposit();
    const { entity } = this.state;

    switch (type) {
      case 'fixed': {
        const options = [0, 100, 200, 250, 500, 1000, 2000, 3000, 4000, 5000];
        const res = [];

        _forEach(options, option => {
          res.push(
            <MenuItem key={option} eventKey={option}>
              <FormattedNumber
                value={option}
                style="currency"
                currency={entity.currency || (entity.getCurrency && entity.getCurrency())}
              />
            </MenuItem>
          );
        });

        return res;
      }

      case 'percent':
      default: {
        const res = [
          <MenuItem key="no-deposit" eventKey={0}>
            <FormattedNumber value={0} style="percent" />
          </MenuItem>,
        ];

        for (let i = 0; i < 4; i++) {
          res.push(
            <MenuItem key={i} eventKey={5 + i * 5}>
              <FormattedNumber value={(5 + i * 5) / 100} style="percent" />
            </MenuItem>
          );
        }

        return res;
      }
    }
  };

  // user selected a variant option
  changePositionVariant = selectedVariant => {
    const { editedRow, itemVariantValidation, entity } = this.state;
    const tree = ['positions', editedRow];
    const editPosition = entity.getPositions()[editedRow];

    if (selectedVariant) {
      const grossPrice = selectedVariant.pricing.price;
      const netPrice = grossPrice / (1 + selectedVariant.pricing.vat_rate / 100);
      this.updateEntityMultiple(['variant', 'netPrice'], [selectedVariant, netPrice], [tree, tree]);
      this.updateVatRate(selectedVariant.pricing.vat_rate);

      this.setState({
        itemVariantValidation: {
          ...itemVariantValidation,
          [editPosition.item.id]: true,
        },
      });
    } else {
      this.setState({
        itemVariantValidation: {
          ...itemVariantValidation,
          [editPosition.item.id]: false,
        },
      });
    }
  };

  isItemVariantValid = itemId => {
    const { itemVariantValidation } = this.state;

    if (typeof itemVariantValidation[itemId] === 'boolean') {
      return itemVariantValidation[itemId];
    }

    return true;
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          const { quote } = this.props;
          const { owner } = this.state;
          if (this.state.entity.isValid) {
            this.props.onSubmit(quote.id || quote.getId(), { ...this.state.entity.processedData, owner });
          }
        }
      );
    }, 150);

    return false;
  };

  addItem = item => {
    const { entity } = this.state;

    const grossPrice = item.pricing.price;
    const vatRate = item.pricing.vat_rate || item.pricing.vatRate;
    const data = {
      id: item.id,
      name: item.name,
      quantity: 1,
      net_price: getNetFromGross(grossPrice, vatRate),
      gross_price: grossPrice,
      vat_rate: vatRate,
      item,
    };

    const positions = entity.getPositions().slice();
    positions.push(data);

    this.updateEntity('positions', positions, [], () => {
      this.setState({ showAddItem: false, editedRow: positions.length - 1 });
    });
  };

  handleDeleteClick = (e, index) => {
    const { entity } = this.state;

    const positions = entity.getPositions().slice();
    positions.splice(index, 1);

    this.updateEntity('positions', positions);
  };

  showPositionPrice = position => {
    const { webApp } = this.props;
    return <FormattedNumber value={position.getNetPrice()} style="currency" currency={webApp.currency} />;
  };

  showPositionName = position => {
    const {
      appIntl,
      intl: { messages },
    } = this.props;
    let variantDescription = '';

    if (position.variant && position.variant.id) {
      variantDescription = getVariantDescription(position.variant, appIntl, messages);
    }

    return (
      <>
        <div class="bold">{position.name}</div>
        {variantDescription}
      </>
    );
  };

  showPositionVatRate = position => {
    if (position.getVatRate() >= 0 && position.getVatRate() !== null) {
      return <FormattedNumber value={position.getVatRate() / 100} style="percent" />;
    }

    return 'n/a';
  };

  showEditDeliveryDate = e => {
    e.preventDefault();
    this.setState({ showEditDeliveryDate: true });
  };

  showEditComment = e => {
    e.preventDefault();
    this.setState({ showEditComment: true });
  };

  showAddItem = e => {
    e.preventDefault();
    this.setState({ showAddItem: true });
  };

  handleEditClick = (e, editedRow) => {
    this.setState({ editedRow });
  };

  handleEditCancelClick = () => {
    this.setState({ editedRow: null });
  };

  handleEditCloseClick = () => {
    this.setState({ editedRow: null });
  };

  updatePosition = (name, value) => {
    const { editedRow } = this.state;
    this.updateEntity(name, value, ['positions', editedRow]);
  };

  updateOwner = (fieldName, owner) => {
    this.setState({ owner });
  };

  vatRateOptions = () => {
    const { user } = this.props;

    const options = [
      <MenuItem key="n/a" eventKey={null}>
        n/a
      </MenuItem>,
    ];
    for (let i = 0; i < user.financial.vat_rates.length; i++) {
      options.push(
        <MenuItem key={user.financial.vat_rates[i]} eventKey={user.financial.vat_rates[i]}>
          <FormattedNumber value={user.financial.vat_rates[i] / 100} style="percent" />
        </MenuItem>
      );
    }

    return options;
  };

  updateVatRate = vatRate => {
    const { entity, editedRow } = this.state;
    const tree = ['positions', editedRow];
    this.updateEntityMultiple(
      ['vatRate', 'grossPrice'],
      [vatRate, getGrossFromNet(entity.getPositions()[editedRow].getNetPrice(), vatRate)],
      [tree, tree]
    );
  };

  updateDocTemplate = (fieldName, docTemplate) => {
    this.updateEntityMultiple([fieldName, 'numberPrefix'], [docTemplate, docTemplate.number_prefix]);
  };

  onShow = () => {
    const { quote, meta } = this.props;

    this.entity.setData({
      lead: quote.lead || quote.getLead(),
      target: quote.target || quote.getTarget(),
      target_organisation:
        quote.target_organisation || (quote.getTargetOrganisation && quote.getTargetOrganisation()) || null,
      positions: quote.positions || quote.getPositions(),
      currency: quote.currency || quote.getCurrency(),
      vat_name: quote.vat_name || quote.getVatName(),
      delivery_date: quote.delivery_date || (quote.getDeliveryDate && quote.getDeliveryDate()) || null,
      comment: quote.comment || (quote.getComment && quote.getComment()) || null,
      is_auto_generated: false,
      is_authorized: false,
      deposit: quote.deposit || (quote.getDeposit && quote.getDeposit()) || 0,
      deposit_type: quote.deposit_type || (quote.getDepositType && quote.getDepositType()) || 'percent',
    });

    if (meta[entityMetaMapping.quote] !== undefined && !meta[entityMetaMapping.quote].pending) {
      this.entity.setMeta(meta, entityMetaMapping.quote);

      this.setState({
        entityLoaded: true,
        entity: this.entity,
      });
    }
  };

  onExit = () => {
    this.entity = new Entity();
    this.setState({ entity: null, entityLoaded: false, entityChanged: false, editedRow: null, showAddItem: false });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      webApp,
      formStatus,
      user,
      quote,
      variants,
    } = this.props;
    const { entity, entityLoaded, editedRow, owner, showEditDeliveryDate, showEditComment, showAddItem } = this.state;

    const disabled = formStatus.pending;
    const timezone = user && user.profile ? user.profile.timezone : 'UTC';
    const deposit = this.getDeposit();

    return (
      <React.Fragment>
        <Data dataName="quote" />
        <FormErrors formStatus={formStatus} />

        {entityLoaded ? (
          <form type="post" onSubmit={this.onSubmit}>
            <Row className="m-b-20">
              <Col xs={12} sm={6}>
                <div className="form-group-attached">
                  <FormHoldingCompany
                    onChange={this.updateOwner}
                    selectedClient={owner && owner.username}
                    disabled={disabled}
                  />
                  <FormAutocomplete
                    label={messages.document_template}
                    name="docTemplate"
                    value={docTemplateOptionFromEntity(entity.getDocTemplate())}
                    onChange={this.updateDocTemplate}
                    returnValueObject
                    autocompleteType="docTemplate"
                    disabled={disabled}
                    urlFilters={{ filters: { language: appIntl.locale, systemType: 'quote' } }}
                    clearable
                    responseFilter={docTemplateOption =>
                      docTemplateOption.id !== (quote && quote.doc_template && quote.doc_template.id)
                    }
                  />
                  <FormAutocomplete
                    label={messages.target_organisation}
                    name="targetOrganisation"
                    value={clientOptionFromEntity(entity.getTargetOrganisation())}
                    meta={entity.getTargetOrganisationMetaInformation()}
                    validation={entity.getTargetOrganisationValidationResult()}
                    onChange={this.updateEntity}
                    returnValueObject
                    autocompleteType="client"
                    disabled={disabled}
                    clearable
                  />
                </div>
                <p className="m-t-15 form-group-title" />
                <div className="form-group-attached">
                  {showEditDeliveryDate ? (
                    <DatePicker
                      value={entity.getDeliveryDate()}
                      locale={appIntl.locale}
                      displayTz={timezone}
                      onChange={this.updateEntity}
                      label={messages.delivery_date}
                      disabled={disabled}
                      name="deliveryDate"
                    />
                  ) : (
                    <div
                      className="form-group form-group-default p-t-10 p-b-10 cursor"
                      onClick={this.showEditDeliveryDate}
                    >
                      <label>
                        {messages.delivery_date} <i class="m-l-10 fa fa-pencil-alt" />
                      </label>
                      <Clearfix className="text-master">
                        {entity.getDeliveryDate() ? (
                          <IntlDate date={entity.getDeliveryDate()} />
                        ) : (
                          messages.edit_delivery_date
                        )}

                        <Button class="text-danger pull-right" bsSize="xsmall" onClick={this.resetDeliveryDate}>
                          <i class="fa fa-times" />
                        </Button>
                      </Clearfix>
                    </div>
                  )}

                  {showEditComment || entity.getComment() ? (
                    <FormRichEditor
                      name="comment"
                      label={messages.comment}
                      value={entity.getComment()}
                      meta={entity.getCommentMetaInformation()}
                      validation={entity.getCommentValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  ) : (
                    <div className="form-group form-group-default p-t-10 p-b-10 cursor" onClick={this.showEditComment}>
                      <label>
                        {messages.comment} <i class="m-l-10 fa fa-pencil-alt" />
                      </label>
                      <span className="text-master">{messages.edit_comment}</span>
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Table hover={!disabled}>
              <thead>
                <tr>
                  <th>{messages.salesDoc.name}</th>
                  <th>{messages.salesDoc.unit_price}</th>
                  <th>{user.financial.vat_name} %</th>
                  <th>{messages.salesDoc.quantity}</th>
                  <th className="text-right">{messages.actions}</th>
                </tr>
              </thead>
              <tbody>
                {entity.getPositions().map((position, i) => {
                  const editMode = editedRow === i && !disabled;

                  return (
                    <tr key={position.getId()} className={editedRow !== null && editedRow !== i ? 'hint-text ' : ''}>
                      {editMode && position.item.variants && (
                        <List
                          noRender
                          listName="itemVariants"
                          url={'/api/items/' + position.item.id + '/variants.json'}
                          list={variants}
                        />
                      )}
                      <td className="v-align-middle">
                        {this.showPositionName(position)}{' '}
                        {editMode &&
                          position.item.variants &&
                          position.item.variants.attributes &&
                          position.item.variants.attributes.length > 0 &&
                          (variants.pending ? (
                            <Loader />
                          ) : (
                            <ItemVariantSelectors
                              item={position.item}
                              variants={variants.data.list}
                              selectedVariant={position.variant ? position.variant : variants.data.list[0]}
                              changeVariant={this.changePositionVariant}
                            />
                          ))}
                      </td>
                      <td className="v-align-middle">{this.showPositionPrice(position)}</td>
                      <td className="v-align-middle">
                        {editMode ? (
                          <DropdownButton
                            class="no-border bg-transparent"
                            id="quote-vat-rate-dropdown"
                            title={this.showPositionVatRate(position)}
                            pullRight
                            onSelect={this.updateVatRate}
                          >
                            {this.vatRateOptions()}
                          </DropdownButton>
                        ) : (
                          this.showPositionVatRate(position)
                        )}
                      </td>
                      <td className="v-align-middle">
                        {editMode ? (
                          <FormInput
                            type="number"
                            name="quantity"
                            value={position.quantity}
                            onChange={this.updatePosition}
                          />
                        ) : (
                          position.quantity
                        )}
                      </td>
                      <td className="text-right v-align-middle">
                        {editMode && (
                          <React.Fragment>
                            <Button
                              className="m-r-5"
                              onClick={e => {
                                this.handleEditCancelClick(e);
                              }}
                            >
                              <i className="fal fa-ban" />
                            </Button>
                            <Button
                              onClick={e => {
                                this.handleEditCloseClick(e);
                              }}
                              disabled={!this.isItemVariantValid(position.item.id)}
                            >
                              <i className="fal fa-check" />
                            </Button>
                            {!this.isItemVariantValid(position.item.id) && (
                              <div className="text-danger m-t-20">{messages.no_valid_variant}</div>
                            )}
                          </React.Fragment>
                        )}
                        {editedRow === null && (
                          <React.Fragment>
                            <Button
                              onClick={e => {
                                this.handleEditClick(e, i);
                              }}
                            >
                              <i className="fa fa-pencil-alt" /> {messages.edit}
                            </Button>{' '}
                            <Button
                              onClick={e => {
                                this.handleDeleteClick(e, i);
                              }}
                            >
                              <i className="fal fa-trash-alt" />
                            </Button>
                          </React.Fragment>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {showAddItem ? (
              <div className="p-t-20 p-b-20 form-group-attached">
                <FormItemSearch onSelect={(name, item) => this.addItem(item)} disabled={formStatus.pending} />
              </div>
            ) : (
              <div className="p-t-20 p-b-20 text-center">
                <Button onClick={this.showAddItem} className="btn-rounded" bsStyle="primary">
                  <i className="fa fa-plus" /> {messages.add_product}
                </Button>
              </div>
            )}

            <Row className="m-b-20">
              <Col xs={12} md={6} mdOffset={6}>
                <hr />
                <Row className="text-right">
                  <Col xs={4}>
                    <DropdownButton
                      className="no-border bg-transparent"
                      id="deposit-type-dropdown"
                      title={messages.deposit + ' (' + deposit.typeLabel + ')'}
                      pullRight
                      onSelect={depositType => this.updateEntityMultiple(['deposit', 'depositType'], [0, depositType])}
                    >
                      <MenuItem key="percent" eventKey="percent">
                        %
                      </MenuItem>
                      <MenuItem key="fixed" eventKey="fixed">
                        {webApp.currencySymbol}
                      </MenuItem>
                    </DropdownButton>
                  </Col>
                  <Col xs={8}>
                    <DropdownButton
                      className="no-border bg-transparent"
                      id="deposit-value-dropdown"
                      title={deposit.valueLabel}
                      pullRight
                      onSelect={depositValue => this.updateEntity('deposit', depositValue)}
                    >
                      {this.depositValueOptions()}
                    </DropdownButton>
                  </Col>
                </Row>
                <hr />
                <SalesDocumentSummary doc={entity} />
              </Col>
            </Row>

            <div className="text-right m-t-50">
              <Button bsStyle="primary" bsSize="lg" disabled={formStatus.pending || editedRow !== null} type="submit">
                {formStatus.pending && <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" />}

                {messages.save}
              </Button>
            </div>
          </form>
        ) : (
          <Loader />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    appIntl: state.intl,
    meta: state.entityMeta,
    formStatus: state.formStatus.convertQuoteFromTemplate,
    user: state.login.user,
    variants: state.list.itemVariants,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (quoteId, args) => {
      formStatusDispatchHelper(
        'convertQuoteFromTemplate',
        `/api/quotes/${quoteId}/convertFromTemplate.json`,
        args,
        'put',
        dispatch
      );
    },
    onFormSuccessfull: () => {
      dispatch(formReset('convertQuoteFromTemplate'));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ConvertQuoteFromTemplateForm)
  )
);
